<template>
  <div class="code">
    <div class="code_list">
      <div
        class="item van-hairline--bottom"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="item_left van-ellipsis">{{ item.title }}</div>
        <div class="item_right">
          <span @click="openCodePop(item)">二维码</span>
        </div>
      </div>
    </div>
    <van-popup
      class="code_box"
      position="bottom"
      round
      closeable
      v-model="show"
    >
      <div class="code_header">咨询师二维码</div>
      <div class="img_box">
        <img :src="codeImg" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Toast } from "vant";
import { getFaceCode } from "@/api/lcapi";
export default {
  name: "MyCodeList",
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      show: false,
      list: "",
      codeImg: ""
    };
  },
  mounted() {
    this.getFaceCode();
  },
  methods: {
    /**
     * 打开二维码弹窗
     */
    openCodePop(item) {
      this.codeImg = item.cr_code;
      this.show = true;
    },
    /**
     * 获取二维码列表
     */
    getFaceCode() {
      getFaceCode()
        .then(res => {
          if (res.status == 200) {
            this.list = res.data;
          } else {
            Toast({ message: "暂无数据" });
            this.$router.go(-1);
          }
        })
        .catch(err => {
          Toast({ message: "暂无数据" });
          this.$router.go(-1);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.code {
  .code_list {
    padding-top: 0.2rem;
    .item {
      padding: 0.2rem 0.3rem;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item_left {
        font-size: 0.32rem;
        width: calc(100% - 1rem);
        line-height: 0.6rem;
        padding-right: 0.2rem;
      }
      .item_right {
        width: 1.5rem;
        background: #ff410a;
        border-radius: 0.08rem;
        text-align: center;
        span {
          display: inline-block;
          color: #ffffff;
          line-height: 0.5rem;
          font-size: 0.24rem;
        }
      }
    }
  }
  .code_box {
    text-align: center;
    padding: 0.32rem;
    .code_header {
      font-size: 0.34rem;
      font-weight: bold;
      margin: 0.5rem 0;
    }
    .img_box {
      width: 3rem;
      height: 3rem;
      margin: 0 auto;
      border-radius: 0.06rem;
      overflow: hidden;
      margin-bottom: 1rem;
      img {
        width: 100%;
      }
    }
    .code_btn {
      width: 4rem;
      height: 0.8rem;
      background: #ff410a;
      border: 0.01rem solid #ff410a;
      border-radius: 0.4rem;
      color: #fff;
      line-height: 0.78rem;
      margin: 0.5rem auto;
    }
  }
}
</style>
